import { clsx } from 'clsx'
import styles from './LayoutSelectTab.module.css'

type ItemType = {
  id: string
  title: string
  count?: number
}

type LayoutSelectableTabsProps = {
  items: ItemType[]
  onChange: (id: string) => void
  value: string
}

const getTabLineTransform = (currentTab: string, tabList: ItemType[]): string => {
  if (!tabList.length) return ''

  const currentIndex = tabList.findIndex((item) => item.id === currentTab)
  if (currentIndex === -1) return ''

  return `translate3d(${currentIndex * 100}%, 0, 0)`
}

export const LayoutSelectTab = ({ items, onChange, value }: LayoutSelectableTabsProps) => {
  const tabLineTransform = getTabLineTransform(value, items)

  return (
    <div className={styles.container}>
      <div
        className={styles.tabWrapper}
        style={
          {
            '--tab-count': items.length,
            '--tab-transform': tabLineTransform,
          } as React.CSSProperties
        }
      >
        {items.map(({ id, title, count }) => {
          const isSelected = value === id

          return (
            <div key={id} className={clsx(styles.statusTab, 'button')} onClick={() => onChange(id)}>
              <span className={isSelected ? 'font-body2-bold' : 'font-body2-regular gray-500'}>{title}</span>
              {typeof count === 'number' && (
                <div className={styles.count} suppressHydrationWarning>
                  {count}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
